const constant = {
    volunteerDomain: 'volunteer.myactivecenter.com',
    volunteerDomain2: 'volunteers.myactivecenter.com',
    driversDomain: 'drivers.myseniorcenter.net',
    appDomain: 'app.myseniorcenter.net',
    // kitchenDomain: 'kitchen.myseniorcenter.net',
    // kitchenDomain: '3803-2400-adc1-150-2100-812d-4f3f-dd40-cc68.ngrok-free.app',
    kitchenDomain: 'kitchens.myseniorcenter.net',
    kitchenDomain2: 'kitchens.myactivecenter.com',
    kitchenDomain3: 'kitchen.myseniorcenter.net',
    cateringDomain: 'caterers.myseniorcenter.net',
    cateringDomain2: 'caterers.myactivecenter.com',
    // kitchenDomain: 'localhost',
    localDomain: 'localhost',
    qaDomain: 'qa1.xtecsoft.com',
    // mealsDomain: 'mow.myseniorcenter.net',
    mealsDomain: 'meals.myseniorcenter.net',
    // mealsDomain: 'localhost',
    // mealsDomain: 'mobile-test.myseniorcenter.net',
    // mealsDomain: 'ba26-2400-adc1-150-2100-3c7a-3d5e-8b0c-e497.ngrok-free.app',

};

constant.driverProtectedDomains = [constant.driversDomain];

constant.volunteerProtectedDomains = [constant.volunteerDomain, constant.volunteerDomain2];

constant.mealsProtectedDomains = [constant.localDomain, constant.qaDomain, constant.mealsDomain]

constant.appProtectedDomains = [constant.appDomain]

constant.kitchenProtectedDomains = [constant.kitchenDomain, constant.kitchenDomain2, constant.kitchenDomain3, constant.cateringDomain, constant.cateringDomain2]

export default constant;
